// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .custom-date-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: -webkit-fill-available;
  width: fill-available;
  width: 99%;
} */

input[type="date"] {
  border: 1px solid rgb(212, 212, 212);
  background-color: #ffffff;
  font-size: 14px;
  color: #999;
}

.custom-date-input-container {
  display: flex;
  position: relative;
  justify-content: flex-end;
}

.date-input-svg {
  position: absolute;
  margin-top: 9px;
  margin-right: 10px;
  pointer-events: none;
}

.custom-date-input {
  appearance: none;
  border: 1px solid rgb(212, 212, 212);
  border-radius: 4px;
  height: 35px;
  padding: 0 10px;
  width: 100%;
  width: -webkit-fill-available;
}

.from-date-placeholder {
  color: initial !important;
}

.dateInput:focus,
.dateInput.has-value {
  color: black;
}

.custom-date-input.has-value {
  color: black;
}

.custom-date-input::placeholder {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #999;
  /* content: attr(placeholder); */
  /* position: absolute; */
  /* top: 52%; */
  /* left: 10px; */
  /* transform: translateY(-50%); */
}

.dateInput:focus::before {
  content: "" !important;
  display: none;
}

.custom-date-input:focus,
.custom-date-input:hover {
  outline: 1px solid rgb(8, 145, 178);
  border: none;
}

.invalid-input {
  box-shadow: rgb(220 38 38) 0px 0px 0px 1px;
  border-color: rgb(220, 38, 38) !important;
}

.invalid-input::before {
  top: 52% !important;
}

.webdateInput::-webkit-calendar-picker-indicator {
  display: none;
}

.webdateInput::-webkit-inner-spin-button {
  display: none;
}

.mobile-input-date-field:before {
  content: "dd/mm/yyyy" !important;
}

.mobile-input-date-field:focus:before {
  content: "dd/mm/yyyy" !important;
}

.mobile-input-date-field {
  display: flex;
}

.custom-time-input {
  width: 100% !important
}`, "",{"version":3,"sources":["webpack://./src/components/dateInput/style.css"],"names":[],"mappings":"AAAA;;;;;;;GAOG;;AAEH;EACE,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EAGE,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;;EAEE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;AACF","sourcesContent":["/* .custom-date-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  width: -webkit-fill-available;\n  width: fill-available;\n  width: 99%;\n} */\n\ninput[type=\"date\"] {\n  border: 1px solid rgb(212, 212, 212);\n  background-color: #ffffff;\n  font-size: 14px;\n  color: #999;\n}\n\n.custom-date-input-container {\n  display: flex;\n  position: relative;\n  justify-content: flex-end;\n}\n\n.date-input-svg {\n  position: absolute;\n  margin-top: 9px;\n  margin-right: 10px;\n  pointer-events: none;\n}\n\n.custom-date-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 1px solid rgb(212, 212, 212);\n  border-radius: 4px;\n  height: 35px;\n  padding: 0 10px;\n  width: 100%;\n  width: -webkit-fill-available;\n}\n\n.from-date-placeholder {\n  color: initial !important;\n}\n\n.dateInput:focus,\n.dateInput.has-value {\n  color: black;\n}\n\n.custom-date-input.has-value {\n  color: black;\n}\n\n.custom-date-input::placeholder {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n  color: #999;\n  /* content: attr(placeholder); */\n  /* position: absolute; */\n  /* top: 52%; */\n  /* left: 10px; */\n  /* transform: translateY(-50%); */\n}\n\n.dateInput:focus::before {\n  content: \"\" !important;\n  display: none;\n}\n\n.custom-date-input:focus,\n.custom-date-input:hover {\n  outline: 1px solid rgb(8, 145, 178);\n  border: none;\n}\n\n.invalid-input {\n  box-shadow: rgb(220 38 38) 0px 0px 0px 1px;\n  border-color: rgb(220, 38, 38) !important;\n}\n\n.invalid-input::before {\n  top: 52% !important;\n}\n\n.webdateInput::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\n.webdateInput::-webkit-inner-spin-button {\n  display: none;\n}\n\n.mobile-input-date-field:before {\n  content: \"dd/mm/yyyy\" !important;\n}\n\n.mobile-input-date-field:focus:before {\n  content: \"dd/mm/yyyy\" !important;\n}\n\n.mobile-input-date-field {\n  display: flex;\n}\n\n.custom-time-input {\n  width: 100% !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
